<template>
	<div class="index">
		<section class="banner">
			<router-link :to="{ name: 'about'}">
		    	<img src="../static/imgs/banner.jpg">
			</router-link>
		</section>
		<section class="slideImg">
		    <h2 class="tit">展览印象</h2>
		    <ul class="fix" ref="list" v-bind:style="{width:width+'rem',display:display}">
		        <li v-for="item in exhibitList">
		            <router-link tag="a" :to="{path:'exDetail',query:{id:item.id}}">
		                <span class="img"><img :src="item.cover_thumb" alt=""></span>
		                <span class="txt">{{item.caption}}</span>
		            </router-link>
		        </li>
		    </ul>
		</section>
		<section class="adv360">
			<router-link :to="{ name: 'panorama'}">
		    	<img src="../static/imgs/qj.png" alt="">
		    </router-link>
		</section>
		<section class="news">
		    <h2 class="tit">新闻资讯</h2>
		    <div ref="wrapper" class="wrapper">
		    	<div>
		    		<dl class="fix" v-for="item in newsDate">
		    		    <router-link tag="a" :to="{path:'newsDetail',query:{id:item.id}}">
		    		    <dt>
		    		        <h3 class="newsTit">{{item.caption}}</h3>
		    		        <p class="time">{{item.date}}</p>
		    		    </dt>
		    		    <dd class="newsImg">
		    		        <img :src="item.cover_thumb" alt="">
		    		    </dd>
		    		    </router-link>
		    		</dl>
		    	</div>
		    </div>
		</section>
	</div>
</template>
<script type="text/javascript">
	import BScroll from 'better-scroll'
	export default {
		data(){
			return{
				//定义展览印象样式
				width:'',
				display:'flex',
				//展览印象列表数据
				exhibitList:'',
				//新闻刷新数据定义
				newsDate:[],
				pulldownMsg: '下拉刷新',
				pullupMsg: '加载更多',
				alertHook: 'none',
				p:0,
			}
		},
		created(){
			const that = this;
			this.$nextTick(() => {
			  	this.scroll = new BScroll(this.$refs.wrapper,{       
			  		//初始化better-scroll
			        probeType:1,   //1 滚动的时候会派发scroll事件，会截流。2滚动的时候实时派发scroll事件，不会截流。 3除了实时派发scroll事件，在swipe的情况下仍然能实时派发scroll事件
			        click: true,   //是否派发click事件
			        useTransition:false,  // 防止iphone微信滑动卡顿
			   	}) 
			   	// 滑动过程中事件
			   	this.scroll.on('scroll',(pos)=>{
			   	    if(pos.y<(this.scroll.maxScrollY - 30)){
			   	        //console.log(pos.y)
			   	    }
			   	});  
			   	//滑动结束松开事件
			   	 this.scroll.on('touchEnd',(pos) =>{  //上拉刷新
			   	     if(pos.y<(this.scroll.maxScrollY - 30)){
			   	       this.p++;
			   	       this.getNews();
			   	       //console.log(this.p)
			   	     } 
			   	 })                                  
			})
		},
		mounted(){

			var num=this.$refs.list.children;
			this.width=num.length*5.3;
			this.getexhib();
			this.getNews();
		},
		methods:{
			getexhib(){
				this.$http.get(this.$api+'/exhibit_api.html')
				.then(res => {
				  	this.exhibitList=res.data.data;
				  	//console.log(res,123)
				})
			},
			getNews(){
				this.$http.get(this.$api+'/news_api.html?p'+this.p)
				.then(res => {
					this.newsDate=this.newsDate.concat(res.data.data);
				  	console.log(this.newsDate,123)
				})
			},
			refreshalert(){   
				//刷新成功提示
			    this.alertHook = 'block';
			    setTimeout(()=>{
			        this.alertHook = 'none'
			    },1000)
			}
		}
	}
</script>
<style scoped>
	.banner{width:17.55rem;margin:0 auto;border-radius: .5rem;overflow: hidden;box-shadow: 0 0 .5rem rgba(48,49,51,.2);margin-top:.5rem;}
	.banner img{width:100%}
	.tit{line-height: normal;padding:1.5rem 0 .575rem .6rem;font-size: .75rem;color:#333;}
	.slideImg{padding-left: .6rem;overflow:auto;}
	.slideImg a{display: block;}
	.slideImg li{width:4.8rem;float:left;margin-right: .5rem;}
	.slideImg img{width:4.8rem;height:4.6rem;object-fit:contain;}
	.slideImg .img{display:block;width:4.8rem;height:4.6rem;overflow: hidden;border-radius: .5rem;-webkit-box-orient: horizontal;-webkit-box-pack: center;-webkit-box-align: center;background:#ccc}
	.slideImg .txt{text-align: center;white-space: nowrap;font-size: .75rem;color:#666;display:block;overflow: hidden;text-overflow: ellipsis;padding:.5rem 0;line-height: normal;}
	.adv360{margin:1.5rem .6rem 0;border-radius: .5rem;overflow: hidden;}
	.adv360 img{width:17.55rem;height:3.5rem;object-fit:cover;}
	.news{padding:0 .6rem;}
	.news dl{padding:.5rem 0;height:5rem;border-bottom: 1px solid #ddd;}
	.news dt{width:12.5rem;float:left;height:4rem;position: relative;}
	.news .newsTit{font-size: .65rem;line-height: 1rem;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;color:#000}
	.news .time{position: absolute;width:100%;font-size: .55rem;color:#999;left:0;bottom:0;}
	.news dd{float:right;width:4rem;height:4rem;overflow: hidden;border-radius: .5rem;}
	.news img{width:100%;height:100%;object-fit:cover;}
	.wrapper{width: 100%;height:400px;overflow:hidden;position:relative;}
</style>